import axios from 'axios';
import { Modal, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { config } from '../../../../base/constant';
import styles from "./meetingschedule.module.scss";
import iconpdf from "../../../../styles/images/grid_pdf.svg";
import iconppt from "../../../../styles/images/grid_ppt.svg";
import iconword from "../../../../styles/images/grid_word.svg";
import iconxls from "../../../../styles/images/grid_xls.svg";
import iconzip from "../../../../styles/images/grid_zip.svg";
import iconxd from "../../../../styles/images/grid_xd.svg";
import iconimage from "../../../../styles/images/grid_image.svg";
//import iconmusic from "../../../../styles/images/grid_music.svg";
import {
  bytesToSize, excelMimeFormats, getCookie,
  imageFormatType,
  pptMimeFormats,wordMimeFormats, zipMimeFormats
} from '../../../../base/utils';
import { useSelector } from 'react-redux';
import ImageZoom from '../../../chat/chatsection/imagezoom';
import { isArray } from 'lodash';
import { getFileExt, shortFileName, toastInformation } from '../../../../base/callService/common';


type fileUploadProps = {
  files: Function;
};

type fileUploadState = {
  pdfViewer: string;

  fileUpload: Array<any>;
  fileName: string;
  fileData: any;
  fileDetail: any;
  isModalFileVisible: any;
  isModalImageVisible: any;
}

export default function FileUpload_MeetingCreation({files}:fileUploadProps) {
  let { meetingReducer }: any = useSelector((state: any) => state);
  let { detailPage,currentWindowState } = meetingReducer;
  const [getData, setData] = useState<fileUploadState>({
    pdfViewer: '',
    isModalFileVisible: false,
    isModalImageVisible:false,
    fileUpload: [],
    fileName: "",
    fileData: [],
    fileDetail:{}
  });

  useEffect(() => {
    if (currentWindowState === "editMeeting" || currentWindowState === 'useTemplate' ) {
      setData({ ...getData, fileData: detailPage.files, fileUpload: detailPage.files });
    }
  },[]);
  const showModalHide = (file: any) => {
    if (imageFormatType.includes(file.mimeType)) {
      setData({ ...getData, isModalImageVisible: true,fileName:file.fileName,fileDetail:file});}
  else {
   let URL = `https://drive.google.com/viewerng/viewer?embedded=true&url=${file.fileUrl}#toolbar=0&scrollbar=0`;
    setData({ ...getData, isModalFileVisible: true,pdfViewer:URL,fileName:file.fileName,fileDetail:file});
  }
  };

  const closeModal = () => {
    setData({ ...getData, isModalFileVisible: false,isModalImageVisible:false});
  };

  const downloadFile = () => {
    var xhr = new XMLHttpRequest();
  xhr.open("GET", getData.fileDetail.fileUrl, true);
  xhr.responseType = "blob";
  xhr.onload = function () {
    var urlCreator = window.URL || window.webkitURL;
    var imageUrl = urlCreator.createObjectURL(this.response);
    var tag = document.createElement("a");
    tag.href = imageUrl;
    tag.download = getData.fileDetail.fileName;
    document.body.appendChild(tag);
    tag.click();
    document.body.removeChild(tag);
  };
    xhr.send();
    
  }
  const removeAttachedFiles = (index: number) => {
    let { fileUpload } = getData;
    fileUpload.splice(index, 1);
    setData({ ...getData, fileUpload: fileUpload });
    let fileData:any = [];
    fileUpload.map((file: any) => {
      let data: any = {};
      data.fileUrl = file.geturl;
      data.fileName = file.filename;
      data.fileSize = file.size;
      data.fileType = file.mimetype;
      fileData.push(file);
    });
    files(fileData);
  };

  const attachFiles = async(e: any) => {
    let choosedFile: any = e.target.files;
    if (!config().ACCEPTED_FILE_TYPE.includes(choosedFile[0].type)) {
      toastInformation("File Type Not Supported", "failed");
      return;
    }
    let token:any = getCookie("ssoToken");
    let formData = new FormData();
    for  (let i = 0; i < choosedFile.length; i++) { formData.append("doc",choosedFile[i]); };

    const url: string = `${config().CHAT_RESTAPI_URL}/upload/files`;
    var authkey = {
      "Content-Type": "application/json",
      Authorization: token };
    await axios
      .post(url, formData, { headers: authkey })
      .then((response: any) => {
        if (response.data.statusCode === 200) {
          let { fileUpload } = getData;
          response?.data?.files?.forEach(async(element: any) => {
            let data: any = {};
            data.fileUrl = element.geturl;
            data.fileName = element.filename;
            data.fileSize = element.size;
            data.mimeType = element.mimetype;
            fileUpload.push(data);
          });
          files(fileUpload);
        }
      }).catch(function(error: any) { console.log("error is",error); });
  };
  return (
    <>
      <div className={styles.formGroup}>
        <div className={styles.fileAttchconsec}>

          {isArray(getData?.fileUpload) && getData?.fileUpload?.map((file: any, index:number) => {
            return (
              <div key={index} className={styles.fileAttachList}  >
                <div className={styles.filesImage}>
                  <img src={wordMimeFormats.indexOf(file?.mimeType) > -1
                  ? iconword :
                  pptMimeFormats.indexOf(file.mimeType)>-1
                    ? iconppt: file?.mimeType==="application/pdf"?
                      iconpdf:excelMimeFormats.indexOf(file.mimeType)>-1
                        ? iconxls : zipMimeFormats.indexOf(file.mimeType) > -1
                          ? iconzip : imageFormatType.indexOf(file.mimeType) > -1 ? iconimage: iconxd
                } alt="filename" />
                </div>
                <div className={styles.filesDetails}>
                  <span className={styles.fileName}>{`${shortFileName(file.fileName)}..${getFileExt(file.fileName)}`}</span>
                  <span className={styles.fileDt}>{ bytesToSize(file.fileSize)}file</span>
                </div>
                <div><span
                  className={`icon_zoom2 ${styles.icnseachbg}`} onClick={() => showModalHide(file)}></span></div>
                <div className={styles.hoverClick}>
                  <Tooltip placement="top" title={'Remove File'}>
                    <span className="icon_close" onClick={() => removeAttachedFiles(index)}></span>
                  </Tooltip>
                </div>
              </div>
            );
          })
          }

          {/* <div className={styles.fileAttachList}>
            <div className={styles.filesImage}><img src={iconxls} alt="filename" /></div>
            <div className={styles.filesDetails} >
              <span className={styles.fileName}>Audio_transcribe</span>
              <span className={styles.fileDt}>4 MB Excel</span>
            </div>
            <div onClick={()=>showModalHide(true)}><span className={`icon_zoom2 ${styles.icnseachbg}`}></span></div>
            <div className={styles.hoverClick}>
              <Tooltip placement="top" title={'Remove File'}>
                <span className="icon_close"></span>
              </Tooltip>
            </div>
            <div className={styles.loadingIcon}>
              <object data={file_loader} type="image/svg+xml">Loading...</object>
            </div>
          </div> */}
            
        </div>

        { <div className={getData.fileUpload?.length < 10 ? styles.attachfilecon : `${styles.customdisable} ${styles.attachfilecon}`} >
          <div className={styles.attachconsec}>
            <input type="file" id="upload" accept= {config().ACCEPTED_FILE_TYPE} onChange={(e:any)=>attachFiles(e)} disabled={getData.fileUpload?.length < 10 ? false : true} hidden multiple/>
            <label htmlFor="upload" className={styles.customUpload}>
              <span className={`icon_Newdoc ${styles.plueiconcenter}`}></span>
              <span className={styles.editUploadText}>Attached Document </span>
            </label>
            {/* <Upload>
              <span className={`icon_Newdoc ${styles.plueiconcenter}`}></span>
              <span className={styles.editUploadText}>Attached Document</span>
            </Upload> */}
          </div>
        </div>}
      </div>
      <Modal 
        centered
        visible={getData.isModalFileVisible}
        onCancel={closeModal}
        className="imagepreviewmodal">
        <div className="modalheaders">
          <h2>{getData.fileName}</h2>
          <ul>
                    <li><Tooltip placement="top" title={'Download'}>
              <span className="icon_Downloadstroke"
                onClick={downloadFile}></span></Tooltip></li>
            <li>
              <Tooltip placement="top" title={'Close'}
            >
              <span className="icon_close" onClick={closeModal}>
              </span></Tooltip></li>
          </ul>
        </div>
         <div className={styles.imageSec}>
          <div><img src={getData.fileDetail.fileUrl} alt=""/> </div></div>
        <div className="chatNoteImgContent">
          <iframe title={"webview"}
            src={getData.pdfViewer}
            frameBorder="0"
            scrolling="auto"
            height="400"
            width="100%"
          >
          </iframe>
         
        </div>
      </Modal>
         <Modal visible={getData.isModalImageVisible} className="imagepreviewmodal">
        <div className="modalheaders">
          <h2>{getData.fileDetail.fileName}</h2>
          <ul>
            {/* <li>
              <Tooltip placement="top" title={'Delete'}>
                <span className="icon_delete" ></span></Tooltip></li>  */}
                <li><Tooltip placement="top" title={'Download'}>
              <span className="icon_Downloadstroke"
                onClick={downloadFile}></span></Tooltip></li>
            <li><Tooltip placement="top" title={'Close'}
            >
              <span className="icon_close" onClick={closeModal}>
              </span></Tooltip></li>
          </ul>
        </div>
        <div className="imagepreview">
          <ImageZoom url={getData.fileDetail.fileUrl} ></ImageZoom>
        </div>
      </Modal>
    </>);
}